export interface Response {
  code: number;
  msg: string;
}

export interface ResponseWithData<T> extends Response {
  data: T;
}

// 對應 malasun 的 AccountSignupType enum（帳號註冊方式）
export enum LinkedAccountSignupType {
  EMAIL = 0,
  FB = 1,
}

// 40102（社群帳號已被其他專案連結）時 data 附的綁定者資訊。
// email 已由後端遮罩（如 s5****7s@gmail.com），前端拿不到完整值；
// 欄位可能為 null（後端查不到綁定者帳號），顯示端必須 fallback 回原本的 generic 訊息。
export interface LinkedAccountInfo {
  accountEmail: string | null;
  signupType: LinkedAccountSignupType | null;
}
